

















import { i18n } from '@/i18n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { handleSpShare, SpShareHelperParams } from '@tencent/wphk-components-wecoupon/components/share-channel';
import { markShowTips, shouldShowTips } from './business/show-tips-storage';
@Component({
  components: {
  },
})
export default class ShareIcon extends Vue {
  @Prop() shareParams!: SpShareHelperParams ;
  shouldShowTip = shouldShowTips();
  i18n = i18n;

  onClickShare() {
    markShowTips();
    this.shouldShowTip = shouldShowTips();

    handleSpShare(this.shareParams); // merchnt-dialog退出时, 记得要重设回抢券有so分享
  }
}
